<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Parcialmente
      <span
        v-b-tooltip.hover
        title="Cadastros sem peso e/ou altura na vigência e ano atuais, e sem verificação com o MS."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        v-model="totalmente"
        @change="onChangeTotalmente($event)"
      />
      <span class="orange"></span> Totalmente
      <span
        v-b-tooltip.hover
        title="Cadastros com peso e altura registrados na vigência e ano atuais."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        v-model="verificado"
        @change="onChangeVerificado($event)"
      />
      <span class="green"></span> Verificado
      <span
        v-b-tooltip.hover
        title="Cadastros em que a vigência e o ano atuais coincidem com os dados do MS (dados_ms)."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    setRed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      totalmente: false,
      verificado: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue) {
        if (newValue === true) {
          this.totalmente = false
          this.verificado = false
          this.reds = true
        }
      },
    },
  },
  methods: {
    /**
     * Limpa os checkboxes de filtro de cor.
     */
    limparFiltros() {
      this.reds = false
      this.totalmente = false
      this.verificado = false
    },

    /**
     * Marca Verificado como filtro padrão.
     */
    marcarVerificado() {
      this.reds = false
      this.totalmente = false
      this.verificado = true
    },

    onChangeReds(event) {
      this.totalmente = false
      this.verificado = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeTotalmente(event) {
      this.reds = false
      this.verificado = false
      this.$emit('exibirVerdes', event.target.checked)
    },
    onChangeVerificado(event) {
      this.reds = false
      this.totalmente = false
      this.$emit('exibirVerificados', event.target.checked)
    },
  },
}
</script>

<style></style>
